import { getIdToken } from 'firebase/auth';
import { auth } from '../../../../firebase';

const refreshTokenIfExpired = async () => {
  const user = auth.currentUser;
  if (user) {
    return await getIdToken(user);
  }
  return null;
};

export const fetchWrapper = async (url, options = {}, isBlob = false) => {
  // Add query parameters to the URL if any are provided in options
  if (options.params) {
    const queryString = new URLSearchParams(options.params).toString();
    url += `?${queryString}`;
  }
  const token = await refreshTokenIfExpired();
  if (token) {
    localStorage.setItem('token', token);
  }

  const defaultHeaders = {
    'Content-Type': 'application/json',
    'x-token': token,
  };

  const config = {
    headers: { ...defaultHeaders, ...options.headers },
    ...options,
  };

  try {
    const response = await fetch(url, config);

    // Handle HTTP errors
    if (!response.ok) {
      const errorMessage = await response.text();
      const error = new Error(errorMessage || 'Something went wrong');
      error.status = response.status;
      throw error;
    }

    if (isBlob) return response.blob(); // Blob response

    // Assume JSON response
    return response.json();
  } catch (error) {
    console.error('Fetch error:', error.status, error.message);
    throw error;
  }
};
